// fieldState is copied from ControllerFieldState in react-hook-form.
export function inputPropsFromField(fieldState: {
  invalid: boolean;
  error?: { message?: string | undefined } | undefined;
}) {
  return {
    isInvalid: fieldState.invalid,
    errorMessage: fieldState.error?.message,
    // Rules is not yet available as render prop.
    // See https://github.com/react-hook-form/react-hook-form/issues/12164
    // isRequired: rules?.required
  };
}
